import * as React from 'react';
import { cn } from '@restworld/utils-common';
export const selectLabelStyle = 'flex justify-between items-center text-neutral-700 text-base font-medium mb-2';
export const selectSecondaryLabelStyle = 'text-sm font-normal text-neutral-100';
export const selectInteractiveAreaStyle =
  'appearance-none h-12 relative w-full border border-neutral-90 cursor-pointer flex items-center justify-between rounded-lg bg-neutral-10 py-3 px-4 text-left transition duration-200 ease-in-out hover:bg-neutral-30 focus-visible:outline-[8px] focus-visible:outline-red-200 disabled:bg-neutral-40';
export const selectInteractiveAreaContentStyle = 'text-base font-medium text-neutral-700';
export const selectOptionsStyle =
  'absolute mt-2 max-h-[304px] w-full overflow-auto rounded-lg z-50 bg-neutral-10 scrollbar-none p-2 text-base border border-neutral-90 shadow-[0px 4px 16px 0px rgba(0, 0, 26, 0.25)]';
export const selectOptionStyle =
  'relative cursor-pointer select-none py-0 px-5 h-12 flex items-center text-base text-neutral-700 font-medium hover:bg-neutral-30 hover:rounded-lg';
export type HelperTextVariantType = 'error' | 'info' | 'success';

export const SelectMainWrapper = ({ fullwidth, twStyle, className, ...props }: any) => (
  <div className={cn(fullwidth ? 'w-full' : 'w-[320px]', twStyle, className)} {...props} />
);
export const ListboxContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('relative mt-1', className)} {...props} />
);
export const SecondaryLabel = ({ className, ...props }: any) => (
  <span className={cn(selectSecondaryLabelStyle, className)} {...props} />
);
export const ListboxButtonContent = ({ className, ...props }: any) => (
  <span className={cn(selectInteractiveAreaContentStyle, 'inline-block truncate pr-2', className)} {...props} />
);
export const IconAndTextWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <span className={cn('flex items-center gap-2', className)} {...props} />
);
export const ArrowIconWrapper = ({ isOpen, className, ...props }: any) => (
  <span className={cn('min-w-[24px] transition-transform', isOpen ? 'rotate-180' : '', className)} {...props} />
);
export const StyledSelectHelperText = ({ variant, className, ...props }: any) => (
  <span
    className={cn(
      'text-sm font-normal mt-2 inline-block',
      variant === 'error' ? 'text-red-500' : variant === 'success' ? 'text-green-500' : 'text-neutral-700',
      className
    )}
    {...props}
  />
);
export const StyledPlaceholder = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <span className={cn('text-base font-normal text-neutral-200', className)} {...props} />
);
